export const isFollowUpInspection = (object: any) => {
  if (!object || !object.data) {
    return false;
  }

  const { isFollowUpInspectionOf } = object.data() || {};

  return !!isFollowUpInspectionOf;
};
